export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Users/Components/AnonymousLoginComponent.vue'),
    contentData: {
        key: 'LoginAdminConsole',
        visible: true
    }
};